module.exports = __webpack_public_path__ + "static/loading-82facc05a59632b21fee8af747679af7.jpg";